import { render, staticRenderFns } from "./bandeja_pqrs_listadoComponent.vue?vue&type=template&id=6d61c62e&"
import script from "./bandeja_pqrs_listadoComponent.vue?vue&type=script&lang=js&"
export * from "./bandeja_pqrs_listadoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports